import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi'
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '../../_config/constant';


interface resultDataProps { 
  [key: string]: { 
    chartData: any[], 
    tableData: any[]
  } }


export default function CommonMobileDailyRankServiceCo(props: any) {
  const { style, className, type, config, children,data:comData, ...resetProps } = props || {}
  const { api } = config || {}
  const {regionDataType = 'country'} = comData || {};
  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    }
  }, shallowEqual)

  const data = useMemo(() => {
    return {
      gameCode,
      regionDataType
    }
  }, [gameCode,regionDataType])

  const formatData = (data:any) => {
    const resultData:resultDataProps = {};
    for (const key in data) {
      if (Array.isArray(data[key]) && data[key].length > 0) {
        let type = '';
        // type 不能直接用key.split('_')[0]处理，因为指标名称可能本身包含短划线
        if(key?.includes('_date_list')){
          type = key.split('_date_list')[0];
        } else {
          type = key.split('_list')[0];
        }
        resultData[type] = {
          chartData: data[type + '_date_list'],
          tableData: data[type + '_list'],
        };
      }
    }
    return resultData;
  }

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        trackData={['gameCode','regionDataType']}
        formatData={formatData}
        dataKey={'data'}
        beforeRequest={(data) => {
          const { filterVal, gameCode, regionDataType:by_type } = data;
          const { timeType, diff, rangeTime, ...filters } = filterVal || {};
          const params = {
            game_code: gameCode,
            start_time: rangeTime?.[0] || '',
            end_time: rangeTime?.[1] || '',
            // period: PERIODTIMEOBJ[timeType] || 'daily',
            filters: formatFilterValues(filters),
            by_type: by_type
          }
          return params
        }}>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              state: {regionDataType:regionDataType}
            }
          );
        })}
      </Service>
    </div>
  );
};
